export default {
  RICH: 'rich',
  SIMPLE: 'simple',
  DISABLED: 'disabled',
};
